var _ellipse, _path, _path2, _ellipse2, _ellipse3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclaimBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 107,
    viewBox: "0 0 124 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.1958,
    cy: 55,
    rx: 51.8301,
    ry: 52,
    fill: "#E1F0EE",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6136 68.7545C29.6114 68.2876 30.7975 68.7208 31.2628 69.7218C31.728 70.7229 31.2963 71.9129 30.2985 72.3797L23.0718 75.7606C22.074 76.2274 20.8879 75.7943 20.4226 74.7933C19.9573 73.7922 20.389 72.6022 21.3868 72.1354L28.6136 68.7545Z",
    fill: "#C0E3E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3343 75.0375C29.7996 76.0386 29.3679 77.2286 28.3701 77.6954C27.3723 78.1622 26.1862 77.7291 25.7209 76.728L22.351 69.4775C21.8857 68.4765 22.3174 67.2865 23.3153 66.8197C24.3131 66.3529 25.4991 66.786 25.9644 67.7871L29.3343 75.0375Z",
    fill: "#C0E3E0"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 117.019,
    cy: 21.8002,
    rx: 3.58823,
    ry: 3.6,
    stroke: "#C0E3E0",
    strokeWidth: 5
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.77118,
    cy: 36.6002,
    rx: 6.37909,
    ry: 6.4,
    stroke: "#C0E3E0",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6992 95.2995L70.6992 66.6233L80.6403 77.7114L104.728 62.7998L104.728 76.9467L70.6992 95.2995Z",
    fill: "#E2E5EC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9933 62.4564L72.9933 37.6353C72.9933 36.0853 71.3064 35.1244 69.9732 35.915L43.6117 51.548C42.1832 52.3951 42.3498 54.5135 43.8932 55.1269L68.9941 65.1029C69.5854 65.3379 70.2532 65.2775 70.7928 64.9403L72.0533 64.1524C72.6381 63.7869 72.9933 63.146 72.9933 62.4564Z",
    fill: "#E2E5EC",
    stroke: "#BECBE0",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3169 64.7122L42.4313 54.2551C41.1237 53.7647 39.729 54.7313 39.729 56.1277L39.729 82.826C39.729 83.6597 40.2461 84.4059 41.0268 84.6986L70.3169 95.6825M70.3169 64.7122L70.3169 95.6825M70.3169 64.7122L101.366 47.2687C102.7 46.5197 104.346 47.4831 104.346 49.0123L104.346 76.136C104.346 76.8713 103.943 77.5473 103.295 77.8963L70.3169 95.6825",
    stroke: "#BECBE0",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9935 33.7414L41.0672 52.8238C40.2805 53.294 39.2749 53.1693 38.6269 52.5213L31.5581 45.4524C30.6511 44.5455 30.8203 43.0312 31.905 42.3468L60.6027 24.2399C61.3705 23.7555 62.3683 23.8489 63.0328 24.4676L72.9935 33.7414L83.5476 24.2428C84.1094 23.7371 84.9084 23.5914 85.6126 23.8662L112.73 34.4486C114.132 34.9958 114.45 36.8374 113.313 37.8231L105.248 44.813C104.692 45.2943 103.918 45.4323 103.23 45.1724L72.9935 33.7414Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9935 33.7414L41.0672 52.8238C40.2805 53.294 39.2749 53.1693 38.6269 52.5213L31.5581 45.4524C30.6511 44.5455 30.8203 43.0312 31.905 42.3468L60.6027 24.2399C61.3705 23.7555 62.3683 23.8489 63.0328 24.4676L72.9935 33.7414ZM72.9935 33.7414L103.23 45.1724C103.918 45.4323 104.692 45.2943 105.248 44.813L113.313 37.8231C114.45 36.8374 114.132 34.9958 112.73 34.4486L85.6126 23.8662C84.9084 23.5914 84.1094 23.7371 83.5476 24.2428L72.9935 33.7414Z",
    stroke: "#BECBE0",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101.313 47.7437L72.2178 63.8319C71.0663 64.4687 70.8328 66.0248 71.7468 66.9714L79.5691 75.0731C80.2003 75.7268 81.193 75.8728 81.9857 75.4286L112.727 58.2001C113.995 57.4893 114.105 55.7055 112.934 54.8441L103.466 47.8827C102.837 47.4203 101.997 47.366 101.313 47.7437Z",
    fill: "white",
    stroke: "#BECBE0",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.669 74.5665L30.682 63.8367C29.1782 63.2388 28.9702 61.1956 30.3226 60.3068L39.6592 54.1714C40.1845 53.8261 40.8416 53.748 41.4332 53.9604L67.2312 63.2212C68.6401 63.7269 69.0144 65.5443 67.9201 66.5657L59.7725 74.1701C59.207 74.6979 58.3878 74.8523 57.669 74.5665Z",
    fill: "white",
    stroke: "#BECBE0",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4619 7.33563C50.7652 7.5456 49.5867 9.12888 49.8726 10.8145L53.2195 30.5528C53.4878 32.1348 54.9533 33.2256 56.5457 33.0286L57.6299 32.8944C59.226 32.6969 60.3824 31.2759 60.2515 29.6729L58.6222 9.72201C58.4833 8.02182 56.9566 6.7794 55.2637 6.9889L52.4619 7.33563Z",
    fill: "#7FBEB8",
    stroke: "#7FBEB8",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.3423,
    cy: 43.3864,
    r: 5.5,
    transform: "rotate(-7.05461 58.3423 43.3864)",
    fill: "#7FBEB8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclaimBox);
export default __webpack_public_path__ + "static/media/exclaim_box.7ab7e04ff2a4e9e2b205d647db5ffbfd.svg";
export { ForwardRef as ReactComponent };